import { Component, OnInit , ViewChild, ElementRef} from '@angular/core';
import { FormGroup, Validators, FormBuilder,FormControl ,FormGroupDirective, NgForm} from '@angular/forms';
import { Router } from '@angular/router';
import {AuthService}from '../../../../../auth-guard/auth.service';
import {ErrorStateMatcher} from '@angular/material/core';
import {MatDialog} from '@angular/material/dialog';

class CrossFieldErrorMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
      return control.dirty && form.invalid;
    }
  }

@Component({
  selector: 'app-fccp-resetpassword',
  templateUrl: './fccp-resetpassword.html',

})

export class FccpResetpassword implements OnInit {
    resetformpwd:FormGroup;
    resetformpwdtemp:FormGroup;
    hide :any;
    hide1:any;
    hide2:any;
    paramdata:any;
    errorMatcher = new CrossFieldErrorMatcher();
    userdtl:any;
    passwordlabel:string='Old';
   
    constructor(private fb: FormBuilder, private router: Router,private authservice:AuthService,private dialog: MatDialog) {
        this.hide = true;
        this.hide1= true;
        this.hide2= true;
        this.userdtl=this.authservice.getstoragedtl();
        this.intfrom();
        this.passwordlabel = (this.userdtl.reset_flg == 'Y')?'Temporary':'Old';
    }
    intfrom()
    {
        this.resetformpwdtemp = this.fb.group({ 
            temp_password:['', [Validators.required]],
        });

        this.resetformpwd = this.fb.group({
           
            new_password : ['', [Validators.required]],
            conf_password : ['', [Validators.required]]
          },{
            validator: [this.passwordValidator]
            });
        
        
    }


    passwordValidator(form: FormGroup) {
        const condition = form.get('new_password').value !== form.get('conf_password').value;
        return condition ? { passwordsDoNotMatch: true} : null;
      }

    save_resetpwd()
    {
        this.paramdata={};
        this.paramdata.password_txt  = this.resetformpwdtemp.get('temp_password').value;;
        this.paramdata.npassword_txt = this.resetformpwd.get('new_password').value;;
        this.paramdata.user_id       = this.userdtl.user_id;
        
        this.authservice.selectdata('userresetpassword',this.paramdata).subscribe((data:any)=> {
        
            if(data[0].result_cd=='S')
               {
                 this.authservice.resetstoragevalues('reset_flg','N');
                 this.authservice.showSuccess('top-center','Your password has been successfully updated',5000) ; 
                 this.dialog.closeAll();
               }
               else
               {
                 console.log('update password unsucessfull');
                 this.authservice.showToasterror('top-center','You Entered Wrong Password',5000) ; 
                
                 this.resetformpwdtemp.get('temp_password').setErrors({wrongpwd:true});
               }
    
              },
              onerror => 
              {
                console.log("Error man"); 
              });

    }


    ngOnInit() {}

}